interface CloseMenuIconProps {
  size?: number;
}

function CloseMenuIcon({ size = 60 }: CloseMenuIconProps) {
  return (
    <svg
      width={size}
      // height="54"
      viewBox="0 0 60 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.6397 1.52018L10.6818 41.748"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.53407 2.11617L49.3999 41.4445"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58 52.0128L2 52.0016"
        stroke="#ffffff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CloseMenuIcon;
